<template>
  <div class="landing" style="text-align: center">
    <Header />
    <div class="" style="text-align: center; padding-top: 6rem">
      <div>
        <img src="assets/img/logo.svg" alt style="width: 50%; max-width: 40rem; " />
        <h1 style="margin-top: 4rem; font-weight: 300">
          Vítejte na stránkách pivovaru HoppyHedgehog
        </h1>
        <h2>Novinky</h2>
        <div class="container" style="margin-bottom: 3rem;">
          <div class="row no-gutters justify-content-center">
            <div class="col-lg-4 info-box" style="">
              <div>
                <span style="font-size: 1.5rem">🔍</span> <br />
                HoppyHedgehog hledá obchodníka. <br />
                Více info <router-link to="/obchodnik">ZDE</router-link>
              </div>
              <div style="float: right; font-style: italic">
                15. prosince 2021
              </div>
            </div>
            <div class="col-lg-4 info-box">
              <div>
                <span style="font-size: 1.5rem">⚠</span> <br />
                Doprava 🍺 po Praze je až do odvolání ZDARMA.
              </div>
              <div style="float: right; font-style: italic">
                11. listopadu 2020
              </div>
            </div>
          </div>
        </div>
        <div class="no-gutters" style="background: #333">
          <Items />
        </div>
        <h2>O nás</h2>
        <div class="container">
          <div class="row" style="padding-top: 2rem">
            <div class="col-md-6 team-img">
              <img
                src="assets/img/tym.jpeg"
                alt="Náš tým"
                style="width: 70%; max-width: 50rem;padding-bottom:1rem"
              />
            </div>
            <div class="col-md-6 team-text">
              <p>
                K myšlence vařit vlastní pivo nás, stejně jako mnohé jiné pivovarníky, přivedla láska k tomuto zlatavému
                nápoji i chuť vlastnoručně si vyzkoušet jeho výrobu. Vrhli jsme se tedy na studium chemických vzorečků a
                postupů, druhů chmele a sladu i mnohého dalšího, aby na Vánoce roku 2012 vznikla naše první várka piva.
                Během let jsme ve skromných domácích podmínkách navařili na 50 várek piva různých chutí, vůní a síly.
                Postupně jsme tříbili svůj um, prohlubovali své znalosti, učili se z chyb a radovali z úspěchů. Naše
                piva začala získávat pochvalné ohlasy od rodiny, přátel a zanedlouho i od prvních zákazníků.
              </p>
              <p>
                Od roku 2018 fungujeme jako létající pivovar a nyní, na sklonku roku 2020, jsme založili firmu s názvem
                Pivo&amp;Co s.r.o., zaštiťující piva značky HoppyHedgehog, jejímž cílem je oslovit širší okruh pivních
                fanoušků.
              </p>
              <p>
                Rádi bychom naše zákazníky zaujali rozmanitostí pivních stylů, které s ohledem na sezónu pravidelně
                střídáme, poctivým a srdcařským přístupem ke každé uvařené várce i nápaditým designem naší značky.
                Přejeme si, aby Vám naše piva chutnala, a těšíme se, až Vás v budoucnu budeme moci přivítat ve vlastním
                pivovaru, kde si společně připijeme tradičním pivovarnickým
                <span style="font-style: italic">Dej Bůh štěstí</span> 🍺🍺🍺.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Items from "../components/Items";
import Header from "../templates/Header";

export default {
  name: "Index",
  components: {
    Items,
    Header,
  },
  created() {
    console.log(this.$apipath);
    var self = this;
    this.$store.dispatch("fetchCart", { self: this }).catch((err) => {
      self.$store.commit("addNotification", {
        text: "Chyba načtení položek košíku. " + err.message,
        type: "alert",
      });
    });
  },
  computed: {
    test() {
      return this.$store.state.test;
    },
    cartItemsCount() {
      let count = 0;
      if (this.$store.state.cart !== undefined) {
        this.$store.state.cart.forEach((element) => {
          count += element.count;
        });
      }

      return count;
    },
  },
};
</script>
<style scoped>
.info-box {
  background: rgb(51, 51, 51);
  padding: 1rem;
  margin: 0.5rem;
}
</style>
